export default __webpack_public_path__ + "static/media/third-slide-bg.aceb724f.png";